// 3rd Party
import FsLightbox from 'fslightbox-react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Components
import { FlexRow } from 'common/styles/oc-styled-components';

import CONFIG from '../../../../../app.config';
import { selectDataClinicPhotos } from '../../connect/selectors';
import {
  ProfileSubsectionBody,
  ProfileSubsectionHeader,
  ProfileSubsectionTitle,
} from '../../profile-styled-components';

// Other

import { Img, ImgContainer } from './styled-components';

const ProfileOfficePhotos = () => {
  const clinicPhotos = useSelector(selectDataClinicPhotos);
  const [toggler, setToggler] = useState(false);

  return (
    <section>
      <ProfileSubsectionHeader>
        <ProfileSubsectionTitle fontSize="18px">Photos</ProfileSubsectionTitle>
      </ProfileSubsectionHeader>
      <ProfileSubsectionBody>
        <FlexRow align="flex-start" flexWrap="wrap" margin="0 0 70px 0">
          {clinicPhotos
            && clinicPhotos.slice(0, 5).map((photo) => (
              <ImgContainer
                key={photo.name}
                onClick={() => setToggler(!toggler)}
              >
                <Img
                  alt=""
                  src={`${CONFIG.S3_BUCKET_URL}${photo.name}-700x700.${
                    photo.extension
                  }`}
                />
                <div className="overlay" />
              </ImgContainer>
            ))}
        </FlexRow>
        <FsLightbox
          toggler={toggler}
          type="image"
          sources={clinicPhotos.map(
            (photo) =>
              `${CONFIG.S3_BUCKET_URL}${photo.name}-700x700.${photo.extension}`,
          )}
        />
      </ProfileSubsectionBody>
    </section>
  );
};

export default ProfileOfficePhotos;
